export default function CheckboxInput({
  id,
  checked,
  onChange,
  required,
  ...props
}) {
  return (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      required={required}
      className="accent-red-600 w-5 h-5"
      {...props}
    />
  );
}
